import React from 'react'
import { FaLongArrowAltLeft } from 'react-icons/fa'
import { FlexCenter, Padding } from '../../../styles/CommonStyles'
import { DetailText } from '../../../styles/TransactionHistoryStyles'
import { ItemRow } from '../../../styles/newStyles/MobileModal.styled'
import { formatDate, formatNumber } from '../../../core/utils/common'
import { useMainContext } from '../../../core/contexts/main'
import Text from '../../../core/utils/Text'
import CoinImg from '../../common/CoinImg'

const AccountTraceDetailsModal = ({ data, onClose }) => {
    const {
        main: { lang },
    } = useMainContext()

    const diffBalance = data.balanceNew - data.balance
    const diffBlocked = data.balanceBlockedNew - data.balanceBlocked

    const balanceColor =
        diffBalance > 0 ? 'text-green-500' : diffBalance < 0 ? 'text-red-500' : 'text-gray-400'
    const blockedColor =
        diffBlocked > 0 ? 'text-green-500' : diffBlocked < 0 ? 'text-red-500' : 'text-gray-400'

    const typeColor =
        data.type === 'INCREASE'
            ? 'text-green-600'
            : data.type === 'DECREASE'
                ? 'text-red-500'
                : 'text-gray-400 dark:text-gray-500'

    return (
        <div>
            <FlexCenter width='100%'>
                <Padding padding='10px 0' style={{ borderBottom: '1px solid #ffffff15' }}>
                    <DetailText>
                        <Text tid='see-details' />
                    </DetailText>
                </Padding>
            </FlexCenter>

            <div className='p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4'>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='currency' className='text-pcolor-light text-sm' />
                    <FlexCenter className='gap-2'>
                        <CoinImg id={data.currency} size={20} />
                        <span>{data.currency?.toUpperCase()}</span>
                    </FlexCenter>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='volume' className='text-pcolor-light text-sm' />
                    {formatNumber(data.volume, { type: data.currency })}
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='balanceChange' className='text-pcolor-light text-sm' />
                    <FlexCenter className='gap-2'>
                        <span>{formatNumber(data.balance, { type: data.currency })}</span>
                        <FaLongArrowAltLeft
                            className={`${balanceColor} ${lang === 'en' ? 'rotate-180' : ''}`}
                        />
                        <span>{formatNumber(data.balanceNew, { type: data.currency })}</span>
                    </FlexCenter>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='balanceBlockChange' className='text-pcolor-light text-sm' />
                    <FlexCenter className='gap-2'>
                        <span>{formatNumber(data.balanceBlocked, { type: data.currency })}</span>
                        <FaLongArrowAltLeft
                            className={`${blockedColor} ${lang === 'en' ? 'rotate-180' : ''}`}
                        />
                        <span>{formatNumber(data.balanceBlockedNew, { type: data.currency })}</span>
                    </FlexCenter>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='type' className='text-pcolor-light text-sm' />
                    <div className={`rounded-md py-1 px-2 text-center ${typeColor}`}>
                        <Text tid={data.type} />
                    </div>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='cause' className='text-pcolor-light text-sm' />
                    <div className='rounded-md py-1 px-2 text-center bg-gray-200 dark:bg-gray-800 text-sm'>
                        <Text tid={data.cause?.label} />
                    </div>
                </ItemRow>

                <ItemRow>
                    <Text tid='date' className='text-pcolor-light text-sm' />
                    <div className='flex flex-col gap-1'>
                        <span>{formatDate(data.createdAt, 'time', lang)}</span>
                        <span>{formatDate(data.createdAt, 'date', lang)}</span>
                    </div>
                </ItemRow>
            </div>
        </div>
    )
}

export default AccountTraceDetailsModal
